<template>
  <v-dialog v-model="mostrar" max-width="500" persistent>
      <v-card>
          <v-toolbar color="primary" dark dense flat
            ><h3>Modificar dependencia</h3></v-toolbar
          >
          <v-container>
              <v-row no-gutters>
                  <v-col cols="12">
                      <v-text-field
                          v-model="nombreLocal"
                          name="DP-nombre"
                          label="Nombre"
                          type="text"
                          :disabled="loading"
                          color="blue-grey"
                          outlined
                          dense
                          :error-messages="nombreErrors"
                          @input="validarNombre()"
                          @blur="validarNombre()"
                      >
                      </v-text-field>
                  </v-col>
              </v-row>
          </v-container>
          <v-divider class="mx-3"></v-divider>
          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" small outlined @click="$emit('cancelar')"
                >Cancelar</v-btn
              >
              <v-btn
                  color="primary"
                  small
                  :class="{ 'disable-events': blockAceptar }"
                  @click="actualizarDependencia()"
                  >Modificar</v-btn
              >
          </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";

import { actualizarNombreService } from "./dependencias.service";


export default {
  name: "agregarDependencia",
  props: ["mostrar","idDependencia","nombre"],
  mixins: [validationMixin],
  computed: {
    ...mapGetters(["userAdmin"]),
    blockAceptar(){
      if (this.loading) return true;
      if (this.nombreErrors.length > 0) return true;
      if (this.nombreLocal.length == 0) return true;
      return false;
    },
  },
  validations: {
    nombreLocal: {required, minLength: minLength(5) },
  },
  data(){
    return {
      loading: false,
      nombreLocal: "",
      nombreErrors:[],
    };
  },
  created(){
      this.nombreLocal = this.nombre;
  },
  methods: {
    validarNombre() {
      this.$v.nombreLocal.$touch();
      this.nombreErrors = [];
      !this.$v.nombreLocal.required && this.nombreErrors.push("Campo requerido.");
      !this.$v.nombreLocal.minLength && this.nombreErrors.push("Mínimo 5 caracteres.");
    },
    async actualizarDependencia(){
      try {
        this.loading = true;
        const sendData = { 
          idDependencia:  this.idDependencia,
          nombre: this.nombreLocal,
        };

        const serverResponse = await actualizarNombreService(sendData);
        this.loading = false;
        this.$validateResponse(serverResponse);
        if(!serverResponse.ok){
          if (serverResponse.nombreError)
            this.nombreErrors.push(serverResponse.mensaje);
          else this.$$notificarError(serverResponse.mensaje);
        } else {
          const emitData = { 
              idDependencia: this.idDependencia,
              nombre: serverResponse.nombre
            };
          this.$emit("dependenciaModificada", emitData);
        }
      } catch (error) {
        this.loading = false;
        this.$notificarError(error);
      }
    },
  },
};


</script>